import { Colors, Typography, Spacing } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import { Icon20 } from 'builder/components/Icon'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: white;

  ${Media.Tablet`
    gap: ${Spacing['2XS']};
  `};
`

export const ActiveText = styled.span`
  color: ${Colors.Neutral90};
  ${Typography.sizes.Body};
  margin-left: 12px;
`

export const InactiveText = styled.span`
  color: ${Colors.Neutral50};
  ${Typography.sizes.Body};
  margin-left: 12px;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  background-color: ${Colors.Neutral20};

  &.blue {
    background-color: ${Colors.Blue50};
  }
`

export const Tick = styled(Icon20.Tick)`
  color: ${Colors.White};
`

export const NumberIcon = styled.span`
  color: ${Colors.White};
  ${Typography.sizes.Caption};
  ${Typography.weights.demibold};

  &.inactive {
    color: ${Colors.Neutral50};
  }
`

export const Separator = styled.div`
  width: 32px;
  height: 1px;
  background-color: ${Colors.Neutral15};
  margin-left: ${Spacing['2XS']};
  margin-right: ${Spacing['2XS']};
`

export const Bullet = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: ${Colors.Neutral15};

  &.active {
    background-color: ${Colors.Blue50};
  }
`
